import { useReducer, useEffect, useRef, useMemo } from 'react';
import { hashQueryKey } from 'react-query';

const initialState = {
  status: 'idle',
  error: null,
};

export const useLoad = (
  loadKey,
  loadFn,
  { onError, onSettled, onSuccess, enabled = true, select } = {}
) => {
  const [state, dispatch] = useReducer(loadReducer, initialState);
  const loadHashKey = hashQueryKey([loadKey]);

  const loadHashKeyRef = useRef();
  const mountedRef = useRef(false);

  loadHashKeyRef.current = loadHashKey;

  const load = async (hashKey) => {
    let data, error;

    dispatch({ type: 'loading' });
    console.log('useLoad');
    try {
      data = await loadFn();
      if (select) {
        data = select(data);
      }
    } catch (e) {
      error = e;
    }

    if (mountedRef.current && loadHashKeyRef.current === hashKey) {
      if (error) {
        dispatch({ type: 'error', payload: error });
      } else {
        dispatch({ type: 'success', payload: data });
      }
    }
  };

  useMemo(() => {
    if (enabled) {
      load(loadHashKey);
    }
  }, [loadHashKey, enabled]);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    let settled = false;
    switch (state.status) {
      case 'success':
        settled = true;
        onSuccess && onSuccess(state.data);
        break;
      case 'error':
        settled = true;
        onError && onError(state.error);
        break;
    }

    if (settled && onSettled) {
      onSettled(state.data, state.error);
    }
  }, [state]);

  return {
    isLoading: state.status === 'loading',
    isIdle: state.status === 'idle',
    isSuccess: state.status === 'success',
    ...state,
  };
};

function loadReducer(state, action) {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        // data: undefined,
        // error: null,
        status: 'loading',
      };
    case 'error':
      return {
        data: undefined,
        error: action.payload,
        status: 'error',
      };
    case 'success':
      return {
        data: action.payload,
        error: null,
        status: 'success',
      };
    default:
      return state;
  }
}
